import { demoCommunityListingImg } from "utils/assets_exports/images";

export type DemoComunityListObject = {
    title: string;
    img: string;
    id: string;
    members: string;
    newPosts: number;
    status: "active" | "blocked" | "deleted";
    about?: string;
};
export const demoUrGroups: DemoComunityListObject[] = [
    {
        newPosts: 11,
        title: "The family gamers world community",
        id: "@familygamers",
        members: "5.7k",
        status: "active",
        img: demoCommunityListingImg[0]
    },
    {
        newPosts: 64,
        title: "Grandma's cake and cookies oven",
        id: "@grandmaoven",
        members: "12.9k",
        status: "active",
        img: demoCommunityListingImg[1]
    },
    {
        newPosts: 21,
        title: "The house of casual fashionistas",
        id: "@casualfashionistas",
        members: "3.7k",
        status: "active",
        img: demoCommunityListingImg[2]
    },
    {
        newPosts: 2,
        title: "Tales of fire, ice, and flying dragons",
        id: "@flyingdragons",
        members: "2.3k",
        status: "active",
        img: demoCommunityListingImg[3]
    },
    {
        newPosts: 78,
        title: "Passionates of mountain trekking and adventure",
        id: "@passionatesofmountain",
        members: "6.1k",
        status: "active",
        img: demoCommunityListingImg[4]
    },
    {
        newPosts: 45,
        title: "Keep your life balanced - for remote workers",
        id: "@lifebalanced",
        members: "78.5k",
        status: "active",
        img: demoCommunityListingImg[5]
    },
    {
        newPosts: 68,
        title: "Latest straming releases and reviews",
        id: "@stramingreleases",
        members: "686.5k",
        status: "active",
        img: demoCommunityListingImg[6]
    },
    {
        newPosts: 14,
        title: "Creative and healthy recipes for grown ups",
        id: "@healthyrecipes",
        members: "15.7k",
        status: "active",
        img: demoCommunityListingImg[7]
    }
];

export const demoListedGroups: DemoComunityListObject[] = [
    {
        newPosts: 7,
        title: "House of the Beer Experts Society",
        id: "@beerexperts",
        members: "3.4k",
        status: "active",
        img: demoCommunityListingImg[8]
    },
    {
        newPosts: 13,
        title: "Zombie movies fans (only the good ones)",
        id: "@zombiemoviesfans",
        members: "12.6k",
        status: "active",
        img: demoCommunityListingImg[9]
    },
    {
        newPosts: 44,
        title: "Seventies and Eighties music classics",
        id: "@musicclassics",
        members: "125.4k",
        status: "active",
        img: demoCommunityListingImg[10]
    },
    {
        newPosts: 56,
        title: "XVI - XIX European classic paintings",
        id: "@euroclassicpaintings",
        members: "210k",
        status: "active",
        img: demoCommunityListingImg[11]
    },
    {
        newPosts: 84,
        title: "Book lovers association of Kansas",
        id: "@kansasbooklovers",
        members: "3k",
        status: "active",
        img: demoCommunityListingImg[12]
    },
    {
        newPosts: 210,
        title: "Cryptocurrency exchange and discussion group",
        id: "@cryptoexchange",
        members: "210.3k",
        status: "active",
        img: demoCommunityListingImg[13]
    },
    {
        newPosts: 3,
        title: "Scary stories of Edgar A. Poe & HP Lovecraft",
        id: "@scarystories",
        members: "1.7k",
        status: "active",
        img: demoCommunityListingImg[14]
    },
    {
        newPosts: 16,
        title: "Train trips accross Europe and Asia",
        id: "@traintrips",
        members: "203k",
        status: "active",
        img: demoCommunityListingImg[15]
    },
    {
        newPosts: 2,
        title: "The Milwaukee automotive pit stop",
        id: "@milwaukeeautomotive",
        members: "798",
        status: "active",
        img: demoCommunityListingImg[16]
    }
];
export const demoGroupsRequest: DemoComunityListObject[] = [
    {
        newPosts: 7,
        title: "House of the Beer Experts Society",
        id: "@beerexperts",
        about: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptates, eaque!",
        members: "3.4k",
        status: "active",
        img: demoCommunityListingImg[8]
    },
    {
        newPosts: 13,
        title: "Zombie movies fans (only the good ones)",
        id: "@zombiemoviesfans",
        about: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptates, eaque!",
        members: "12.6k",
        status: "active",
        img: demoCommunityListingImg[9]
    }
];
export const demoAllGroups: DemoComunityListObject[] = [
    {
        newPosts: 11,
        title: "The family gamers world community",
        id: "@familygamers",
        members: "5.7k",
        status: "active",
        img: demoCommunityListingImg[0]
    },
    {
        newPosts: 64,
        title: "Grandma's cake and cookies oven",
        id: "@grandmaoven",
        members: "12.9k",
        status: "active",
        img: demoCommunityListingImg[1]
    },
    {
        newPosts: 21,
        title: "The house of casual fashionistas",
        id: "@casualfashionistas",
        members: "3.7k",
        status: "active",
        img: demoCommunityListingImg[2]
    },
    {
        newPosts: 2,
        title: "Tales of fire, ice, and flying dragons",
        id: "@flyingdragons",
        members: "2.3k",
        status: "blocked",
        img: demoCommunityListingImg[3]
    },
    {
        newPosts: 78,
        title: "Passionates of mountain trekking and adventure",
        id: "@passionatesofmountain",
        members: "6.1k",
        status: "active",
        img: demoCommunityListingImg[4]
    },
    {
        newPosts: 45,
        title: "Keep your life balanced - for remote workers",
        id: "@lifebalanced",
        members: "78.5k",
        status: "active",
        img: demoCommunityListingImg[5]
    },
    {
        newPosts: 68,
        title: "Latest straming releases and reviews",
        id: "@stramingreleases",
        members: "686.5k",
        status: "deleted",
        img: demoCommunityListingImg[6]
    },
    {
        newPosts: 14,
        title: "Creative and healthy recipes for grown ups",
        id: "@healthyrecipes",
        members: "15.7k",
        status: "active",
        img: demoCommunityListingImg[7]
    },
    {
        newPosts: 7,
        title: "House of the Beer Experts Society",
        id: "@beerexperts",
        members: "3.4k",
        status: "active",
        img: demoCommunityListingImg[8]
    },
    {
        newPosts: 13,
        title: "Zombie movies fans (only the good ones)",
        id: "@zombiemoviesfans",
        members: "12.6k",
        status: "blocked",
        img: demoCommunityListingImg[9]
    },
    {
        newPosts: 44,
        title: "Seventies and Eighties music classics",
        id: "@musicclassics",
        members: "125.4k",
        status: "active",
        img: demoCommunityListingImg[10]
    },
    {
        newPosts: 56,
        title: "XVI - XIX European classic paintings",
        id: "@euroclassicpaintings",
        members: "210k",
        status: "deleted",
        img: demoCommunityListingImg[11]
    },
    {
        newPosts: 84,
        title: "Book lovers association of Kansas",
        id: "@kansasbooklovers",
        members: "3k",
        status: "active",
        img: demoCommunityListingImg[12]
    },
    {
        newPosts: 210,
        title: "Cryptocurrency exchange and discussion group",
        id: "@cryptoexchange",
        members: "210.3k",
        status: "active",
        img: demoCommunityListingImg[13]
    },
    {
        newPosts: 3,
        title: "Scary stories of Edgar A. Poe & HP Lovecraft",
        id: "@scarystories",
        members: "1.7k",
        status: "blocked",
        img: demoCommunityListingImg[14]
    },
    {
        newPosts: 16,
        title: "Train trips accross Europe and Asia",
        id: "@traintrips",
        members: "203k",
        status: "deleted",
        img: demoCommunityListingImg[15]
    },
    {
        newPosts: 2,
        title: "The Milwaukee automotive pit stop",
        id: "@milwaukeeautomotive",
        members: "798",
        status: "active",
        img: demoCommunityListingImg[16]
    }
];
